import { defineStore } from 'pinia';

export const useCsoPlaybackStore = defineStore('csoPlaybackStore', {
	state: () => ({
		script_playback_elapsed_time: 0,
		script_playback_sync_at: undefined,
		script_playback_status: 'STOPPED',
		current_event_index: undefined,
	}),
	actions: {},
});
